import { Component, OnInit, Inject } from '@angular/core';
import { ToastService } from '../../services/toast.service';
import { StaticValueService } from '../../services/static-value.service';
import {MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';


@Component({
  selector: 'app-upload-file-component',
  templateUrl: './upload-file-component.component.html',
  styleUrls: ['./upload-file-component.component.css']
})
export class UploadFileComponentComponent implements OnInit {

  public uploadedFiles = [];
  public errors: any;
  public tags: any;
  public tagMessage: any;
  public fileUploadErrorMesssage = '';
  public staticDDlist: any;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<UploadFileComponentComponent>,
    public toastService: ToastService,
    public staticDataService: StaticValueService,
  ) { }

  ngOnInit() {
    this.errors = this.staticDataService.errors;
    this.staticDDlist = this.staticDataService.staticData.staticDD;
  }

  fileUploaded(event) {
    if (event.target.files && event.target.files.length > 0) {
      if(event.target.files.length > 3 ) {
          this.toastService.error(this.errors.File['405']);
          event.target.value = null;
          return;
      }
      this.uploadedFiles = [];
      for (let i = 0 ; i < event.target.files.length; i ++ ) {
          const file = event.target.files[i];
          if (file.size > 5000000) {
              this.toastService.error(this.errors.File['402']);
              event.target.value = null;
              this.uploadedFiles = [];
              return;
          }
          if ( file.type === 'application/pdf') {
              const reader = new FileReader();
              reader.readAsDataURL(file);
              reader.onload = () => {
                  this.uploadedFiles.push({
                      filename: file.name,
                      filetype: file.type,
                      imageData: reader.result.split(',')[1]
                      // imageData: ""
                  });
              };
          } else {
              this.toastService.error(this.errors.File['403']);
              event.target.value=null;
              this.uploadedFiles=[];
              return;
          }
      }
  }
  }

  submit() {
      if (this.uploadedFiles.length > 0) {
        this.dialogRef.close({uploadedFiles: this.uploadedFiles, tags: this.tagMessage});
        this.fileUploadErrorMesssage = '';
    } else {
        this.fileUploadErrorMesssage = 'Please upload file'
    }
  }

}
